module.exports = __webpack_public_path__ + "static/media/instagram-relax-tablet.6f25c57a.png";